import { c as _c } from "react/compiler-runtime";
import useProductListingData from 'hooks/useProductListingData';
import { GET_CATEGORY_PAGE } from '@/graphql/queries';
import getVisitorLocationQueryVariables from 'commons/getVisitorLocationQueryVariables';
import useUserLocation from 'global-state/userLocation/useUserLocation';
import useZipCodeFromUser from 'global-state/zipCodeFromUser/useZipCodeFromUser';
const useQuickshipPageData = () => {
  const $ = _c(5);
  const userLocation = useUserLocation();
  const zipCodeFromUser = useZipCodeFromUser();
  const zipCode = userLocation?.zip ?? zipCodeFromUser ?? "";
  const t0 = userLocation?.stateShortName;
  let t1;
  if ($[0] !== t0) {
    t1 = getVisitorLocationQueryVariables(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== zipCode) {
    t2 = {
      variables: {
        slug: "instock",
        zipCode,
        ...t1
      }
    };
    $[2] = t1;
    $[3] = zipCode;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const pageData = useProductListingData(GET_CATEGORY_PAGE, t2);
  return pageData;
};
export default useQuickshipPageData;